export default __webpack_public_path__ + "static/media/animeImage.7ed82947.jpeg";